import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const CHAT_CALLABLE_TIMEOUT_MS = 150_000;

export type ChatWithOpportunityResponse = {
  userMessageId: string;
  assistantMessageId: string;
  reply: string;
};

export function chatWithOpportunityErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Enter a shorter message and try again.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to chat about this opportunity.';
    }
    if (code === 'functions/not-found') {
      return 'This opportunity could not be found.';
    }
    if (code === 'functions/unavailable') {
      return 'Chat is temporarily unavailable. Try again in a moment.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'The reply timed out. Try again in a moment.';
    }
  }
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  return err instanceof Error ? err.message : 'Could not send the message.';
}

export async function chatWithOpportunity(
  opportunityId: string,
  message: string,
  threadId?: string
): Promise<ChatWithOpportunityResponse> {
  const fn = httpsCallable<
    { opportunityId: string; message: string; threadId?: string },
    ChatWithOpportunityResponse
  >(functions, 'chatWithOpportunity', { timeout: CHAT_CALLABLE_TIMEOUT_MS });
  return (
    await fn({
      opportunityId: opportunityId.trim(),
      message: message.trim(),
      ...(threadId ? { threadId: threadId.trim() } : {}),
    })
  ).data;
}
